export default __webpack_public_path__ + "static/media/TOMTOM.a3dc4d4a.png";